module.exports = __webpack_public_path__ + "image/index_pro_img4.png";